/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BridgeApiConversationRequestedFields } from './BridgeApiConversationRequestedFields';
import {
    BridgeApiConversationRequestedFieldsFromJSON,
    BridgeApiConversationRequestedFieldsFromJSONTyped,
    BridgeApiConversationRequestedFieldsToJSON,
    BridgeApiConversationRequestedFieldsToJSONTyped,
} from './BridgeApiConversationRequestedFields';
import type { BridgeApiConversationStatus } from './BridgeApiConversationStatus';
import {
    BridgeApiConversationStatusFromJSON,
    BridgeApiConversationStatusFromJSONTyped,
    BridgeApiConversationStatusToJSON,
    BridgeApiConversationStatusToJSONTyped,
} from './BridgeApiConversationStatus';
import type { BridgeApiConversationCounterparty } from './BridgeApiConversationCounterparty';
import {
    BridgeApiConversationCounterpartyFromJSON,
    BridgeApiConversationCounterpartyFromJSONTyped,
    BridgeApiConversationCounterpartyToJSON,
    BridgeApiConversationCounterpartyToJSONTyped,
} from './BridgeApiConversationCounterparty';

/**
 * a Conversation
 * @export
 * @interface BridgeApiConversation
 */
export interface BridgeApiConversation {
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversation
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversation
     */
    categoryHandle: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversation
     */
    templateId: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversation
     */
    lastMessage?: string;
    /**
     * 
     * @type {BridgeApiConversationTypeEnum}
     * @memberof BridgeApiConversation
     */
    type: BridgeApiConversationTypeEnum;
    /**
     * 
     * @type {BridgeApiConversationStatus}
     * @memberof BridgeApiConversation
     */
    status: BridgeApiConversationStatus;
    /**
     * 
     * @type {Date}
     * @memberof BridgeApiConversation
     */
    lastUpdated: Date;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversation
     */
    attributes?: string;
    /**
     * 
     * @type {BridgeApiConversationRequestedFields}
     * @memberof BridgeApiConversation
     */
    requestedFields?: BridgeApiConversationRequestedFields;
    /**
     * 
     * @type {Array<BridgeApiConversationCounterparty>}
     * @memberof BridgeApiConversation
     */
    counterparties: Array<BridgeApiConversationCounterparty>;
    /**
     * 
     * @type {boolean}
     * @memberof BridgeApiConversation
     */
    urgent: boolean;
    /**
     * Indicates whether conversation conclusion was submitted when closing rfi
     * @type {boolean}
     * @memberof BridgeApiConversation
     */
    isConcluded?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BridgeApiConversation
     */
    creationDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof BridgeApiConversation
     */
    hasConversationKey: boolean;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiConversation
     */
    investigationId: string;
}

/**
* @export
* @enum {string}
*/
export enum BridgeApiConversationTypeEnum {
    SENDER = 'SENDER',
    RECIPIENT = 'RECIPIENT'
}


/**
 * Check if a given object implements the BridgeApiConversation interface.
 */
export function instanceOfBridgeApiConversation(value: object): value is BridgeApiConversation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('categoryHandle' in value) || value['categoryHandle'] === undefined) return false;
    if (!('templateId' in value) || value['templateId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('lastUpdated' in value) || value['lastUpdated'] === undefined) return false;
    if (!('counterparties' in value) || value['counterparties'] === undefined) return false;
    if (!('urgent' in value) || value['urgent'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('hasConversationKey' in value) || value['hasConversationKey'] === undefined) return false;
    if (!('investigationId' in value) || value['investigationId'] === undefined) return false;
    return true;
}

export function BridgeApiConversationFromJSON(json: any): BridgeApiConversation {
    return BridgeApiConversationFromJSONTyped(json, false);
}

export function BridgeApiConversationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiConversation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'categoryHandle': json['categoryHandle'],
        'templateId': json['templateId'],
        'lastMessage': json['lastMessage'] == null ? undefined : json['lastMessage'],
        'type': json['type'],
        'status': BridgeApiConversationStatusFromJSON(json['status']),
        'lastUpdated': (new Date(json['lastUpdated'])),
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
        'requestedFields': json['requestedFields'] == null ? undefined : BridgeApiConversationRequestedFieldsFromJSON(json['requestedFields']),
        'counterparties': ((json['counterparties'] as Array<any>).map(BridgeApiConversationCounterpartyFromJSON)),
        'urgent': json['urgent'],
        'isConcluded': json['isConcluded'] == null ? undefined : json['isConcluded'],
        'creationDate': (new Date(json['creationDate'])),
        'hasConversationKey': json['hasConversationKey'],
        'investigationId': json['investigationId'],
    };
}

export function BridgeApiConversationToJSON(json: any): BridgeApiConversation {
    return BridgeApiConversationToJSONTyped(json, false);
}

export function BridgeApiConversationToJSONTyped(value?: BridgeApiConversation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'categoryHandle': value['categoryHandle'],
        'templateId': value['templateId'],
        'lastMessage': value['lastMessage'],
        'type': value['type'],
        'status': BridgeApiConversationStatusToJSON(value['status']),
        'lastUpdated': value['lastUpdated'].toISOString(),
        'attributes': value['attributes'],
        'requestedFields': BridgeApiConversationRequestedFieldsToJSON(value['requestedFields']),
        'counterparties': ((value['counterparties'] as Array<any>).map(BridgeApiConversationCounterpartyToJSON)),
        'urgent': value['urgent'],
        'isConcluded': value['isConcluded'],
        'creationDate': value['creationDate'].toISOString(),
        'hasConversationKey': value['hasConversationKey'],
        'investigationId': value['investigationId'],
    };
}

